import { PropsWithChildren, ReactElement } from "react";
import styles from "./ScopeLayout.module.less";
import { setTrackingId } from "client/Misc/utils";

export const ScopeLayout = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<div className={styles.root}>
			{children}
		</div>
	);
};
ScopeLayout.displayName = "ScopeLayout";

const ScopeLayoutSettings = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<div
			{...setTrackingId("scope-layout-settings")}
			className={styles.settings}
		>
			{children}
		</div>
	);
};
ScopeLayoutSettings.displayName = "ScopeLayout.Settings";

const ScopeLayoutResults = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<div
			{...setTrackingId("scope-layout-results")}
			className={styles.results}
		>
			{children}
		</div>
	);
};
ScopeLayoutResults.displayName = "ScopeLayout.Results";

ScopeLayout.Settings = ScopeLayoutSettings;
ScopeLayout.Results = ScopeLayoutResults;
